import React from 'react';
import '../../styles/Amenities.css';

const Amenities = () => {
  const amenities = [
    {
      id: 1,
      icon: '🛏️',
      title: 'Luxury Rooms',
      description: 'Well-furnished rooms with modern amenities'
    },
    {
      id: 2,
      icon: '🍽️',
      title: 'Fine Dining',
      description: 'Delicious multi-cuisine dining experience'
    },
    {
      id: 3,
      icon: '📶',
      title: 'Free WiFi',
      description: 'High-speed internet throughout the hotel'
    },
    {
      id: 4,
      icon: '🚗',
      title: 'Free Parking',
      description: 'Complimentary valet parking for guests'
    },
    {
      id: 5,
      icon: '🕐',
      title: '24/7 Service',
      description: 'Round-the-clock room service & assistance'
    },
    {
      id: 6,
      icon: '💕',
      title: 'Couple Friendly',
      description: 'Privacy guaranteed for couples'
    },
    {
      id: 7,
      icon: '⏰',
      title: 'Short Stays',
      description: 'Flexible 4-hour stay packages available'
    },
    {
      id: 8,
      icon: '🚕',
      title: 'Cab Service',
      description: 'Airport pickup & city tour cabs available'
    }
  ];

  return (
    <section className="amn-amenities-section" id="amenities">
      <div className="amn-amenities-container">
        {/* Section Header */}
        <div className="amn-amenities-header">
          <span className="amn-amenities-badge">✦ Premium Amenities</span>
          <h2 className="amn-amenities-title">
            World-Class <span className="amn-highlight">Facilities</span>
          </h2>
          <p className="amn-amenities-subtitle">
            Experience luxury, comfort, and convenience at every step
          </p>
        </div>

        {/* Amenities Grid */}
        <div className="amn-amenities-grid">
          {amenities.map((amenity, index) => (
            <div className="amn-amenity-card" key={amenity.id} style={{ animationDelay: `${index * 0.1}s` }}>
              <div className="amn-amenity-icon-wrapper">
                <span className="amn-amenity-icon">{amenity.icon}</span>
                <div className="amn-icon-glow"></div>
              </div>
              <h3 className="amn-amenity-title">{amenity.title}</h3>
              <p className="amn-amenity-description">{amenity.description}</p>
              <div className="amn-amenity-line"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Amenities;